import React, { useState, useEffect } from "react";
import { useOutletContext, Link } from "react-router-dom";

import "../css/Page__Styles.css";
import "../css/Page__Home.css";

import projectsData from "../data/projects.json";

import IndexCarrusel from "../components/IndexCarrusel.jsx";
import Footer from "../components/Footer.jsx";
import ProjectGrid from "../components/ProjectGrid.jsx";

import PortraitEME from "../img/portrait-eme.png"

// ─────────────────────────────────────────────────────────────
// HOME
// ─────────────────────────────────────────────────────────────



export const Home = () => {

  useEffect(() => {document.title = "Eme / Inicio";}, []);

  return (
    <div className="home__page">


      {/* =====================================================
          HERO
      ===================================================== */}

        <IndexCarrusel />

      {/* =====================================================
          ABOUT
      ===================================================== */}

      <section className="section__about">

        <h1>
          Hola soy Eme, directora de arte especializada en
          diseño editorial y branding.
        </h1>


        <div className="portrait">

          <img
            src={PortraitEME}
            style={{
              height: "100%"
            }}
            alt="Foto retrato de María José"
          />

        </div>

      </section>


      {/* =====================================================
          PROJECT DIRECTORY
      ===================================================== */}

      <section className="section__project_directory">

        <h2>
          Cada proyecto nace de una mirada propia. Mi misión es
          comprenderla, darle forma y crear las conexiones,
          formas y detalles que la conviertan en una identidad
          única, coherente y con carácter.
        </h2>


        <div>

          <ProjectGrid
            projects={projectsData}
          />

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ===================================================== */}

      <Footer />

    </div>
  );
};


export default Home;